"use client";

import { c as _c } from "react/compiler-runtime";
import { FlexCenter, Label, Switch, Tooltip } from "@opensea/ui-kit";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslations } from "use-intl";
export function CustomDestinationWalletToggle(t0) {
  const $ = _c(7);
  const {
    supported,
    required
  } = t0;
  const t = useTranslations("wallet.CustomDestinationWalletToggle");
  const {
    control
  } = useFormContext();
  let t1;
  if ($[0] !== required || $[1] !== supported || $[2] !== t) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <Tooltip content={required ? t("requiredTooltip") : t("unsupportedTooltip")} disabled={supported && !required}><FlexCenter className="ml-1 h-8 justify-between"><Label className="whitespace-nowrap" htmlFor="customDestinationWalletEnabled" size="sm" weight="regular">{t("label")}</Label><Switch checked={field.value} disabled={!supported || required} id="customDestinationWalletEnabled" onCheckedChange={field.onChange} size="sm" /></FlexCenter></Tooltip>;
    };
    $[0] = required;
    $[1] = supported;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== control || $[5] !== t1) {
    t2 = <Controller control={control} defaultValue={false} name="customDestinationWalletEnabled" render={t1} />;
    $[4] = control;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}